import React, { useState, useEffect, useRef } from "react";
import "./Shop.css";

const DesignShop = () => {
	const [imageOne, setImageOne] = useState(500);
	const [imagetwo, setImagetwo] = useState(500);
	const [imagethree, setImagethree] = useState(500);
	const img1Ref = useRef(null);
	const img2Ref = useRef(null);
	const img3Ref = useRef(null);
	useEffect(() => {
		const handleScroll = () => {
			const el = document.querySelector(".shopDiv");
			const textEl = document.querySelector(".shopText");

			if (
				!el ||
				!textEl ||
				!img1Ref.current ||
				!img2Ref.current ||
				!img3Ref.current
			)
				return;

			const screenBottom = window.innerHeight;
			const elPos = el.getBoundingClientRect().top;

			if (elPos < screenBottom && elPos + 150 > 0) {
				textEl.style.visibility = "visible";
				textEl.style.opacity = "1";
				textEl.style.transform = "translateX(0)";
			} else {
				textEl.style.visibility = "hidden";
				textEl.style.opacity = "0";
				textEl.style.transform = "translateX(-300px)";
			}

			const updateImage = (rect, setter) => {
				setter(rect.bottom - 50 < screenBottom ? 0 : 500);
			};

			updateImage(img1Ref.current.getBoundingClientRect(), setImageOne);
			updateImage(img2Ref.current.getBoundingClientRect(), setImagetwo);
			updateImage(img3Ref.current.getBoundingClientRect(), setImagethree);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	return (
		<div className='shop'>
			<div className='shopText'>
				<h2>Sicherheit und Komfort</h2>

				<p>
					Modernes Tandem-Trike, verlässliche Ausrüstung und ein Pilot, der zu
					den lokalen Experten gehört.
				</p>
				{/* <a
					href='https://semko1010.github.io/designShop/'
					target='_blank'
					rel='noreferre'
					className='shop-flip'
					data-back='Design Shop'
					data-front='Show Me'></a> */}
				<ul>
					<li>Aktuelle Sportpilotenlizenz & medizinisches Medical</li>
					<li>Start von offiziellem Flugplatz in Becherbach</li>
					<li>Komfortabler Sitz & ruhiger Startlauf</li>
					<li>Stabiler Polini-Motor für reibungslose Rundflüge</li>
				</ul>
			</div>
			<img
				ref={img1Ref}
				style={{ transform: `translateX(${imageOne}%)` }}
				id='img1'
				src='./img/bilder/shop.jpg'
				alt=''
				className='image1'
			/>
			<img
				ref={img2Ref}
				style={{ transform: `translateX(${imagetwo}%)` }}
				id='img2'
				src='./img/bilder/shop2.png'
				alt=''
				className='image2'
			/>
			<img
				ref={img3Ref}
				style={{ transform: `translateX(${imagethree}%)` }}
				id='img3'
				src='./img/bilder/shop3.png'
				alt=''
				className='image3'
			/>
		</div>
	);
};

export default DesignShop;
